import { render, staticRenderFns } from "./Game.vue?vue&type=template&id=f48b69e4&scoped=true"
import script from "./Game.vue?vue&type=script&lang=js"
export * from "./Game.vue?vue&type=script&lang=js"
import style0 from "./Game.vue?vue&type=style&index=0&id=f48b69e4&prod&scoped=true&lang=css"
import style1 from "./Game.vue?vue&type=style&index=1&id=f48b69e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48b69e4",
  null
  
)

export default component.exports